import styled from 'styled-components';

export const Header = styled.div`
  background-color: #f4f5f6;
  padding: 40px 28px 80px 80px;
  width: 1020px;
  position: relative;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  margin-bottom: 24px;
`;

export const TextColumn = styled.div`
  flex: 0 0 auto;
  letter-spacing: -0.2px;
`;

export const Text = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
  display: grid;
  gap: 12px;
  padding: 24px 24px 40px;
`;

export const Paragraph = styled.p``;

export const SwitcherTabsWrapper = styled.div`
  position: absolute;
  bottom: 0;
`;

export const Content = styled.div`
  padding: 0 28px 28px 80px;
`;

export const ContentSwitcherWrapper = styled.div`
  margin-top: 12px;
`;
export const NoOlympiads = styled.div`
  margin: 85px 0;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: rgba(9, 21, 38, 0.6);
`;
